import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "../api";

export default function NewsletterConfirm() {
  const location = useLocation();
  const [status, setStatus] = useState({ loading: true, error: "", ok: false });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    // Support proxy-appended absolute URL like /newsletter/confirm/https://host/?newsletter=confirmed
    const tail = location.pathname.split("/newsletter/confirm/")[1] || "";
    const tailDecoded = decodeURIComponent(tail);

    // If we detect a success marker in the tail, show success without extra roundtrip
    if (!token && tailDecoded && /newsletter=confirmed/.test(tailDecoded)) {
      setStatus({ loading: false, error: "", ok: true });
      return;
    }

    if (!token) {
      setStatus({ loading: false, error: "Token fehlt.", ok: false });
      return;
    }
    (async () => {
      try {
        const { data } = await api.get("/newsletter/confirm", { params: { token, json: 1 }, headers: { Accept: "application/json" } });
        // Stay on this page and show confirmation instead of auto-redirecting
        setStatus({ loading: false, error: "", ok: true });
      } catch (e) {
        const msg = e?.response?.data?.error || "Bestätigung fehlgeschlagen";
        setStatus({ loading: false, error: msg, ok: false });
      }
    })();
  }, [location.pathname]);

  if (status.loading) return <div style={{ padding: 24 }}><h2 style={{ marginTop: 0 }}>Bestätige Anmeldung…</h2><p>Bitte einen Moment…</p></div>;
  if (status.ok) {
    return (
      <div className="highlight-card" style={{ maxWidth: 720, margin: '40px auto', padding: 24 }}>
        <h2 className="highlight-title" style={{ marginTop: 0 }}>Newsletter‑Anmeldung bestätigt</h2>
        <p>
          Danke! Deine Anmeldung zum AP‑Network Newsletter wurde erfolgreich bestätigt.
        </p>
        <p>
          Du kannst dieses Fenster schließen oder zur Startseite zurückkehren.
        </p>
        <Link to="/" className="hero-btn-primary" style={{ display: 'inline-block', marginTop: 8 }}>Zur Startseite</Link>
      </div>
    );
  }
  return (
    <div className="highlight-card" style={{ maxWidth: 720, margin: '40px auto', padding: 24 }}>
      <h2 className="highlight-title" style={{ marginTop: 0 }}>Newsletter‑Bestätigung</h2>
      <p style={{ color: '#ef4444' }}>{status.error}</p>
      <p>
        Tipp: Öffne den Link erneut oder fordere eine neue Bestätigungs‑E‑Mail an.
      </p>
      <Link to="/" className="hero-btn-secondary" style={{ display: 'inline-block', marginTop: 8 }}>Zur Startseite</Link>
    </div>
  );
}
